import api from '@/api'
import * as types from '../mutation-types'
import router from '../../router'

import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

// initial state
const state = {
  isLoading: false,
  isLogin: false,
  isError: false,
  isMoment: false,
  role: null,
  data: null,
  date: null,
  isPengumuman: false,
  isS2S3: false,
  isAccepted: false,
  isDisable: false,
  dataYudisium: null,
  loadingYudisium: false
}

// getters
const getters = {
  getAuthData: state => state
}

// actions
const actions = {
  login({ commit, dispatch }, data) {
    commit(types.LOGIN_LOADING)
    let endPoint = '/login'
    process.env.NODE_ENV === 'test' ? endPoint = '/login/test' : false
    api.post(endPoint, {
      username: data.username,
      password: data.password
    })
      .then(response => {
        let responseData = response.data
        let mhsJalur = responseData.data.mhs_jalur
        commit(types.LOGIN_REGISTER, responseData.data)
        commit(types.LOGIN_LOADING)
        dispatch('getStatusPendaftar', { nomorPendaftar: mhsJalur.nomor_pendaftar, kodePenawaran: mhsJalur.kode_penawaran })
        dispatch('getAllPengumuman')
        dispatch('getAllArtikel')
        dispatch('getVerificationStatus')
        // dispatch('getYudisiumData')
        router.push({ name: 'DashboardPendaftar' })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.LOGIN_LOADING)
        commit(types.LOGIN_ERROR)
        console.log(e)
      })
  },
  getYudisiumData({ commit, rootState }) {
    let noPeserta = rootState.auth.data.no_peserta
    commit(types.YUDISIUM_LOADING)
    api.post('/v2/cek_yudisium', {
      nomor_peserta: noPeserta
    })
      .then(response => {
        commit(types.YUDISIUM_FINISH_LOADING)
        commit(types.YUDISIUM_CHECK, response.data)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.YUDISIUM_ERROR)
        console.log(e)
      })
  },
  setDisability ({ commit }) {
    commit(types.TOGGLE_DISABILITY, true)
  },
  unsetDisability ({ commit }) {
    commit(types.TOGGLE_DISABILITY, false)
  },
  logout({ commit }) {
    api.post('/logout')
      .then(response => {
        commit(types.LOGOUT)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.LOGIN_LOADING](state) {
    if (!state.isLoading) {
      state.isLoading = true
    } else {
      state.isLoading = false
    }
  },
  [types.LOGIN_REGISTER](state, response) {
    state.isLogin = true
    state.isError = false
    state.role = 'register'
    state.data = response
    localStorage.setItem('client-admisi-token', response.token)
    let kodeJalur = response.mhs_jalur.penawaran_jalur.kode_jalur
    if (kodeJalur === '21' || kodeJalur === '22' || kodeJalur === '23' || kodeJalur === '24' || kodeJalur === '25' || kodeJalur === '31' || kodeJalur === '32' || kodeJalur === '33' || kodeJalur === '34') {
      state.isS2S3 = true
    }
    let mulaiDaftar = response.mhs_jalur.penawaran_jalur.tanggal_mulai_daftar
    let selesaiDaftar = response.mhs_jalur.penawaran_jalur.tanggal_selesai_daftar
    let startDaftar = moment(mulaiDaftar)
    let endDaftar = moment(selesaiDaftar)
    let dateNow = moment()
    let rangeDaftar = moment().range(startDaftar, endDaftar)
    state.isMoment = rangeDaftar.contains(dateNow)
    let announcement = response.pengumuman.tanggal_pengumuman_jalur
    let announcementDate = moment(announcement)
    state.date = announcement
    state.isPengumuman = dateNow.isAfter(announcementDate)
  },
  [types.LOGIN_ERROR](state) {
    state.isError = true
  },
  [types.YUDISIUM_ERROR](state) {
    state.isError = true
  },
  [types.LOGOUT](state) {
    state.isLoading = false
    state.isLogin = false
    state.isError = false
    state.role = null
    state.data = null
    localStorage.removeItem('client-admisi-token')
  },
  [types.YUDISIUM_LOADING](state) {
    state.loadingYudisium = true
  },
  [types.YUDISIUM_FINISH_LOADING](state) {
    state.loadingYudisium = false
    state.isError = false
  },
  [types.YUDISIUM_CHECK](state, response) {
    state.dataYudisium = response.data
    let accepted = response.data.status
    if (accepted === '1') {
      state.isAccepted = true
    } else {
      state.isAccepted = false
    }
    state.isError = false
  },
  [types.TOGGLE_DISABILITY](state, status) {
    state.isDisable = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js